import React from "react";
import {
  AddBoxOutlined,
  CheckBoxOutlined,
  ChevronRight,
  CompareArrows,
  CreditCardOffOutlined,
  EmailOutlined,
  EventBusy,
  EventNote,
  History,
  HistoryEdu,
  InsertChartOutlined,
  IosShare,
  Logout,
  ManageAccountsOutlined,
  MoreTime,
  NewReleasesOutlined,
  PasswordOutlined,
  PendingActions,
  QueryStats,
  ReceiptLongOutlined,
  Security,
  ShowChart,
  StackedBarChart,
  SupportAgentOutlined,
  TrendingUp,
  Update,
  WorkspacePremiumOutlined,
} from "@mui/icons-material";
import BNInlineSvgIcon from "../../Components/BNInlineSvgIcon/BNInlineSvgIcon";
import HomeIcon from "../../Icons/HomeIcon";
import CreditCardIcon from "../../Icons/CreditCardIcon";
import LoanIcon from "../../Icons/LoanIcon";
import SavingsIcon from "../../Icons/SavingsIcon";
import { SxProps, Theme } from "@mui/material/styles";
import { logger } from "../helpers";
import { useLocation } from "react-router";

interface Props {
  src?: string;
  consumer: string;
  iconSx?: SxProps<Theme>;
}

export const IconSrcToMuiMapper: React.FC<Props> = ({ src, consumer, iconSx }) => {
  const { pathname } = useLocation();
  const fileName = src?.split("/").pop();
  const iconName = fileName?.replace(".svg", "");
  const MuiIcon = mapFromIconNameToMuiIcon(iconName);
  if (MuiIcon) {
    return <MuiIcon sx={iconSx} />;
  }
  if (!src) {
    logger.logError(`IconSrcToMuiMapper got empty src. ${consumer} path=${pathname}`);
    return null;
  }
  return <BNInlineSvgIcon src={src} sx={iconSx} />;
};
function mapFromIconNameToMuiIcon(oldIcon?: string) {
  switch (oldIcon) {
    case "add":
      return AddBoxOutlined;
    case "addons":
      return Security;
    case "approved":
      return CheckBoxOutlined;
    case "arrow-right":
      return ChevronRight;
    case "card":
      return CreditCardIcon;
    case "cashback_stroke-icon":
      return WorkspacePremiumOutlined;
    case "card_block":
      return CreditCardOffOutlined;
    case "credit_limit":
      return InsertChartOutlined;
    case "card_pin":
      return PasswordOutlined;
    case "custom_payment":
      return StackedBarChart;
    case "customer_service":
      return SupportAgentOutlined;
    case "dispute":
      return NewReleasesOutlined;
    case "dobbelinvoice":
      return History;
    case "home":
      return HomeIcon;
    case "invoice":
      return ReceiptLongOutlined;
    case "loan":
      return LoanIcon;
    case "loan_application":
      return StackedBarChart;
    case "loan_application_change":
      return Update;
    case "loan_extension":
      return MoreTime;
    case "loan_repaymentplan":
      return EventNote;
    case "loan_payment_free":
      return EventBusy;
    case "loan_topup":
      return TrendingUp;
    case "logout2":
      return Logout;
    case "my_buys":
      return QueryStats;
    case "mailbox":
      return EmailOutlined;
    case "payment":
      return IosShare;
    case "payment_transfer":
      return CompareArrows;
    case "payments_einvoice":
      return HistoryEdu;
    case "payments_pending":
      return PendingActions;
    case "profile":
      return ManageAccountsOutlined;
    case "savings":
      return SavingsIcon;
    case "transactions":
      return ShowChart;
  }
}
